import { z } from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';

const StudentRecognitionFormSchemaWithoutAddress = z.object({
  id: z.number().optional(),
  name: z.string().nonempty({ message: MANDATORY_FIELD }),
  cpf: z.string().nonempty({ message: MANDATORY_FIELD }),
  image: z.string().optional(),
  validUntil: z.string().nullish(),
  recognitionGroupIds: z.number().array(),
  facialControllerIds: z.number().array(),
  deviceGroupIds: z.number().array().nullable(),
  responsibleIds: z.array(z.number()).default([]),
  birthDate: z.string({ required_error: MANDATORY_FIELD })
    .refine((dateStr) => {
      const date = new Date(dateStr);
      const now = new Date();

      now.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);

      return date <= now;
    }, { message: "A data de nascimento não pode estar no futuro." }),
  gender: z.string({ required_error: MANDATORY_FIELD }).nonempty({ message: MANDATORY_FIELD }),
  registration: z.string().nonempty({ message: MANDATORY_FIELD }),
  canGoOut: z.boolean().nullish(),
  classId: z.number().array().nullish(),
  cards: z.string().array().nullish(),
  uc: z.string().array().nullish(),
  type: z.string().nullish(),
});

export const StudentRecognitionFormSchema =
  StudentRecognitionFormSchemaWithoutAddress.superRefine((data, ctx) => {
    if (data.validUntil) {
      const validUntil = new Date(data.validUntil);
      const now = new Date();

      now.setHours(0, 0, 0, 0);
      validUntil.setHours(0, 0, 0, 0);

      if (validUntil.getTime() < now.getTime()) {
        ctx.addIssue({
          path: ['validUntil'],
          code: z.ZodIssueCode.custom,
          message:
            'A data de validade da face não pode ser anterior à data atual.',
        });
      }
    }
  });
